var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12H21C21.5523 12 22 12.4477 22 13V14C22 14.5523 21.5523 15 21 15H20.75C20.75 16.9538 19.9294 19.1433 18.528 20.5326C18.2339 20.8242 17.759 20.8222 17.4674 20.528C17.1758 20.2339 17.1778 19.759 17.472 19.4674C18.56 18.3887 19.25 16.5968 19.25 15.0001L4.75 15C4.75 16.5968 5.43995 18.3887 6.52803 19.4674C6.82219 19.759 6.82424 20.2339 6.53262 20.528C6.241 20.8222 5.76613 20.8242 5.47197 20.5326C4.07059 19.1433 3.25 16.9538 3.25 15.0001L3 15C2.44772 15 2 14.5523 2 14V13C2 12.4477 2.44772 12 3 12H4ZM8.25 12H9.75V11C9.75 10.5858 9.41421 10.25 9 10.25C8.58579 10.25 8.25 10.5858 8.25 11V12ZM11.25 12H12.75V10C12.75 9.58579 12.4142 9.25 12 9.25C11.5858 9.25 11.25 9.58579 11.25 10V12ZM14.2505 12H15.7505L15.75 10.9997C15.7498 10.5854 15.4139 10.2498 14.9997 10.25C14.5854 10.2502 14.2498 10.5861 14.25 11.0003L14.2505 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.c687a1b6ce8e9a8825f008e10c90aaaa.svg";
export { ForwardRef as ReactComponent };